'use strict';

angular.module('atex.dam').directive('damDateTimeFormat', ['configuration', '$filter',
  function (configuration, $filter) {

    var dateTimeFormat = 'yyyy-MM-dd HH:mm:ss';
    var dateFormat = 'yyyy-MM-dd';

    return {
      restrict: 'E',
      template: '<span>{{formattedDate}}</span>',
      replace: true,

      scope: {
        date: "="
      },

      controller: function ($scope) {
        if (configuration.getDateTimeFormat()) {
          dateTimeFormat = configuration.getDateTimeFormat();
        }

        if (configuration.getDateFormat()) {
          dateFormat = configuration.getDateFormat();
        }
      },

      link: function (scope, element, attrs) {
        var format = attrs['noTime'] !== undefined ? dateFormat : dateTimeFormat;
        if (attrs['noTime'] !== undefined) {
          scope.formattedDate = $filter('date')(scope.date, format, 'UTC');
        } else {
          scope.formattedDate = $filter('date')(scope.date, format);
        }
      }
    };
  }
]);
